import { render, staticRenderFns } from "./Hunter.vue?vue&type=template&id=6c42d23a"
import script from "./Hunter.vue?vue&type=script&lang=js"
export * from "./Hunter.vue?vue&type=script&lang=js"
import style0 from "./Hunter.vue?vue&type=style&index=0&id=6c42d23a&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c42d23a')) {
      api.createRecord('6c42d23a', component.options)
    } else {
      api.reload('6c42d23a', component.options)
    }
    module.hot.accept("./Hunter.vue?vue&type=template&id=6c42d23a", function () {
      api.rerender('6c42d23a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Hunter.vue"
export default component.exports